import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/app/src/layout.tsx";
import { price } from "../../../utils/price";
import { rooms } from "../../../data/rooms";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Content = makeShortcode("Content");
const ContentColumns = makeShortcode("ContentColumns");
const Card = makeShortcode("Card");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Content mdxType="Content">
      <p>{`For our guests, we have 14 rooms and apartments available. Each has its own balcony or loggia with a charming view of the surrounding nature. The rooms feature natural materials, mainly wood and stone, which fill them with fantastic comfort and a pleasant mountain atmosphere.`}</p>
    </Content>
    <h2>{`Rooms`}</h2>
    <ContentColumns mdxType="ContentColumns">
	{Object.keys(rooms).map(key => {
        const room = rooms[key];
        return <Card key={key} variant="vertical" image={room.image} title={room.title.en} mdxType="Card">
				{price(room.price)} / night
			</Card>;
      })}
    </ContentColumns>
    <Content mdxType="Content">
      <h2>{`In every room you will find`}</h2>
      <ul>
        <li parentName="ul">{`large double bed`}</li>
        <li parentName="ul">{`bathroom with shower and toilet`}</li>
        <li parentName="ul">{`wardrobe`}</li>
        <li parentName="ul">{`balcony or loggia`}</li>
        <li parentName="ul">{`TV`}</li>
        <li parentName="ul">{`towels and toiletries in the bathroom`}</li>
      </ul>
      <h2>{`Fees`}</h2>
      <ul>
        <li parentName="ul">{`Minimum stay is 2 nights, surcharge for 1 night occupancy is `}<strong parentName="li">{`€10 / room`}</strong></li>
        <li parentName="ul">{`1 person in a Standard double room `}<strong parentName="li">{`€90 / night`}</strong></li>
        <li parentName="ul">{`Tourist tax `}<strong parentName="li">{`1€ / night / adult`}</strong>{`, `}<strong parentName="li">{`0.50€ / night / child under 15`}</strong>{` (ot included in the price)`}</li>
        <li parentName="ul">{`Children under 3 years without bed entitlement `}<strong parentName="li">{`free`}</strong></li>
        <li parentName="ul">{`Baby cot `}<strong parentName="li">{`€20 / stay`}</strong></li>
      </ul>
      <h2>{`Half-board price - breakfast and dinner`}</h2>
      <ul>
        <li parentName="ul">{`Adult `}<strong parentName="li">{`€27 / day`}</strong></li>
        <li parentName="ul">{`Children from 7 to 12 years `}<strong parentName="li">{`€18 / day`}</strong></li>
        <li parentName="ul">{`Children from 3 to 6 years `}<strong parentName="li">{`€13 / day`}</strong></li>
        <li parentName="ul">{`Children under 3 years `}<strong parentName="li">{`free`}</strong></li>
      </ul>
      <p>{`*`}{` All prices include VAT.`}<br />{`
`}{`*`}{` Prices for the period from 26th Dec, including New Year's packages, available on request.`}</p>
      <h2>{`Hotel services`}</h2>
      <ul>
        <li parentName="ul">{`ski equipment rental directly at the hotel`}</li>
        <li parentName="ul">{`storage of ski equipment directly at the hotel - own ski room`}</li>
        <li parentName="ul">{`parking at the hotel`}</li>
        <li parentName="ul">{`board games for families available at reception`}</li>
        <li parentName="ul">{`children's corner`}</li>
      </ul>
    </Content>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      